import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

export const SiteFooter = () => {
  return (
    <footer className="border-t border-black/10 bg-[var(--brand-ink)] text-white">
      <div className="mx-auto grid max-w-7xl gap-8 px-6 py-14 lg:grid-cols-3 lg:px-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="NLCS logo" className="h-11 w-11 object-contain" />
            <span className="font-display text-2xl font-extrabold">NLCS</span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-white/60">
            Nathans Laminating and Copying Service. High-quality printing, laminating, copying
            and scanning for your business and personal needs.
          </p>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Visit us</h4>
          <p className="mt-4 flex items-start gap-2 text-sm text-white/80">
            <MapPin size={18} className="mt-0.5 shrink-0 text-[var(--brand-primary)]" />
            Victoria Road
          </p>
        </div>
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Quick links</h4>
          <div className="mt-4 flex flex-col gap-2 text-sm text-white/80">
            <Link to="/" className="hover:text-white">Home</Link>
            <Link to="/order" className="hover:text-white">Place an Order</Link>
            <Link to="/contact" className="hover:text-white">Contact Us</Link>
            <Link to="/admin" className="hover:text-white">Admin Login</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 py-5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} NLCS, Victoria Road. All rights reserved.
      </div>
    </footer>
  );
};
